var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chip',{staticClass:"ml-3 white marco--text",attrs:{"small":""},on:{"click":_vm.toggleMenuDrawer}},[_vm._v("Menu")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }